module.exports = __webpack_public_path__ + "static/wedo_project-320e42b2e35d48a57f71fe3e8f077df9.svg";